'use strict';

var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function () {
  return {
    container: {
      padding: 4
    }
  };
});

var DrawerHeader = function DrawerHeader(_ref) {
  var children = _ref.children;

  var _useStyles = useStyles(),
      container = _useStyles.container;

  return React__default["default"].createElement("div", {
    className: container
  }, children);
};

module.exports = DrawerHeader;
